<template>
  <div class="step active">
    <transition name="collapse-left">
      <div class="step-label">
        <span class="label">
          {{ $t('global.word.results') }} ({{ resultAmount }})
        </span>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "finish",
  props: {
    resultAmount: {
      type: Number,
      required: true,
    }
  },
}
</script>

<style scoped lang="scss">
.collapse-left-enter-active,
.collapse-left-leave-active {
  transition: all .3s .3s ease;
  overflow: hidden;
  max-width: 200px;
  white-space: nowrap;
}

.collapse-left-leave-active {
  transition: all .3s .1s ease;
}

.collapse-left-enter, .collapse-left-leave-to {
  max-width: 0;
}

.step {
  display: flex;
  position: relative;
  align-items: center;
  font-size: 18px;
  font-family: var(--configurator-font-heading);
  margin-right: 55px;
  color: $secondary;
  cursor: pointer;
  user-select: none;

  @media only screen and (max-width: 576px) {
    margin-right: 20px;
    font-size: 12px;
  }

  &.active {
    cursor: default;
    .step-number {
      background-color: var(--configurator-primary);
    }

    .step-label {
      color: var(--configurator-primary);
    }
  }

  .step-label {
    color: $secondary;

    @media only screen and (max-width: 576px) {
      margin-left: 7px;
    }

    .label {
      font-weight: var(--configurator-font-weight-bold);
      position: relative;
    }
  }
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease;
}

.slide-enter,
.slide-leave-to {
  transform: translate(25%, 0);
  opacity: 0;
}
</style>